import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import CardContainer from "@src/components/cards/CardContainer";
import HorizontalLayout from "@src/components/cards/HorizontalLayout";
import { useDCContext } from "@src/context/dcContext";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

const EventDetailsCard = (props) => {
  const { event, industry, customerCode } = props;
  const isShipping = industry === "shipping";
  const dc = useDCContext();
  const { getDynamicReplacement } = dc;

  let customFlightNumber = `${customerCode}`;
  if (event) {
    customFlightNumber = `${customerCode}-${event.identifier}`;
  }

  return (
    <CardContainer bgColor={"white"} padding={4} shadow={false}>
      {!isShipping ? (
        <div
          className={`text-xl sm:text-4xl md:text-5xl font-bold text-primary-500 capitalize`}
        >
          {event?.eventType?.toLowerCase()} {customFlightNumber}{" "}
          <span className="text-sm sm:text-lg"> {event.vehicle || "N/A"}</span>
        </div>
      ) : (
        <div className="text-xl sm:text-2xl md:text-3xl font-bold text-primary-500 flex justify-between">
          <div>{AppUtils.dateFancyFormatterUTC(event.ocurrenceDatetime)}</div>
          <div className=" text-right">
            {AppUtils.dateFancyFormatterUTC(event.arrivalDatetime)}
          </div>
        </div>
      )}

      <div>
        <HorizontalLayout ratio={[1, 1, 1]} px={0}>
          {/* child 1  - departure data*/}

          <div className="flex flex-col h-full">
            <div>
              {!isShipping
                ? AppUtils.dateFancyFormatterUTC(event.ocurrenceDatetime)
                : AppUtils.formatTime(event.ocurrenceDatetime)}
            </div>
            {!isShipping && (
              <>
                <div className="text-gray-500">
                  {AppUtils.formatTime(event.ocurrenceDatetime)}
                </div>
                <div className="text-gray-500 font-bold">{event.origin}</div>
              </>
            )}
          </div>

          {/* child 2 - middle arrow*/}
          <div className="h-full w-full flex flex-col justify-between">
            <span className="arrow-right"></span>
            <div className="w-full text-center pt-4">
              {!!isShipping ? (
                <div>
                  <div className="text-gray-400 text-sm">
                    {AppUtils.returnJourneyString(
                      event.origin,
                      event.destination,
                    )}
                  </div>{" "}
                  <div className="text-gray-400 text-sm">{event.vehicle}</div>
                </div>
              ) : (
                <div>
                  {event.metadata["aircraft_reg_code"] && (
                    <div className="flex justify-center">
                      <div className="text-gray-500 text-sm">
                        {event.metadata["aircraft_reg_code"]}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* child 3 - arrival data */}
          <div className="flex flex-col items-end h-full">
            <div>
              {!isShipping
                ? AppUtils.dateFancyFormatterUTC(event.arrivalDatetime)
                : AppUtils.formatTime(event.arrivalDatetime)}
            </div>
            {!isShipping && (
              <div className="text-gray-500">
                {AppUtils.formatTime(event.arrivalDatetime)}
              </div>
            )}
            {!!isShipping ? (
              <div className="text-sm text-right">
                {getDynamicReplacement(
                  `captain__events__details__type__${event?.reportType?.toLowerCase().replace(/\s+/g, "_") || "noon"}`,
                )}
              </div>
            ) : (
              <div className="text-gray-500 font-bold">
                {event?.destination}
              </div>
            )}
          </div>
        </HorizontalLayout>
      </div>
    </CardContainer>
  );
};

export const eventDetailsCardControls = {
  event: {
    propType: PropTypes.object,
    description: "Event data object",
    controlType: "object",
  },
  getDynamicReplacement: {
    propType: PropTypes.func,
    description: "Function to get dynamic content",
    disable: true,
  },
  industry: COMMON_CONTROLS.industry,
};

EventDetailsCard.propTypes = AppUtils.getPropTypeFromControls(
  eventDetailsCardControls,
);

export default EventDetailsCard;
